export default __webpack_public_path__ + "static/media/36-BeachKereru.a06afeac.jpeg";